import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isPremium } from './isPremium';
import { isTop } from './isTop';
import { getOfferName } from './title/getOfferName';

export const title: TComputedPropMapper<string> = (props, ctx) => {
  if ((isTop(props, ctx) || isPremium(props, ctx)) && !!props.offer.title) {
    return props.offer.title;
  }

  return getOfferName(props.offer);
};
